export default __webpack_public_path__ + "static/media/contact-us.be8fdc4d.svg";